import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import TextArea from '@zg-rentals/multibrand-ui/lib/TextArea';
import Radio from '@zg-rentals/multibrand-ui/lib/Radio';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import ReviewsConstants from 'app/shared/constants/ReviewsConstants';

// Stylesheets
import './style.scss';

const propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const defaultProps = {
};

const { REPORT_REVIEW_REASONS } = ReviewsConstants;

class ReportReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            errMessage: '',
            reason: REPORT_REVIEW_REASONS.INAPPROPRIATE,
            comment: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
    }

    handleReasonChange(e, reason) {
        this.setState({ reason, errMessage: '' });
    }

    handleCommentChange(e) {
        this.setState({ comment: e.target.value, errMessage: '' });
    }

    handleSubmit() {
        this.setState({
            isSubmitting: true,
        });

        this.props.onSubmit(this.state.reason, this.state.comment)
            .catch(() => {
                this.setState({
                    isSubmitting: false,
                    errMessage: ErrorMessageConstants.DEFAULT_ERROR,
                });
            });
    }

    canSubmit() {
        const {
            reason, comment, isSubmitting, errMessage,
        } = this.state;
        return isSubmitting
            || errMessage !== ''
            || (reason === REPORT_REVIEW_REASONS.OTHER && comment === '');
    }

    render() {
        const {
            reason, comment, isSubmitting, errMessage,
        } = this.state;

        return (
            <div className="ReportReview">
                <Text emphasize={true}>Reason for reporting this review</Text>
                {Object.keys(REPORT_REVIEW_REASONS).map(key => (
                    <Radio
                        key={key}
                        label={ReviewsConstants.REPORT_REVIEW_REASONS_LABEL[key]}
                        checked={reason === REPORT_REVIEW_REASONS[key]}
                        onChange={e => this.handleReasonChange(e, REPORT_REVIEW_REASONS[key])}
                    />
                ))}
                {reason === REPORT_REVIEW_REASONS.OTHER && (
                    <div className="ReportReview-textarea">
                        <TextArea
                            autosize={true}
                            disabled={isSubmitting}
                            placeholder="Tell us why you're reporting this review"
                            value={comment}
                            onChange={this.handleCommentChange}
                        />
                    </div>
                )}
                {errMessage &&
                    <Text type="body-small" danger={true}>{errMessage}</Text>
                }
                <div className="ReportReview-buttons">
                    <Button
                        className="ReportReview-button"
                        type="primary"
                        onClick={this.handleSubmit}
                        disabled={this.canSubmit()}
                    >
                        Report Review
                    </Button>
                    <Button
                        className="ReportReview-button"
                        type="tertiary"
                        onClick={this.props.onCancel}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        );
    }
}

ReportReview.propTypes = propTypes;
ReportReview.defaultProps = defaultProps;

export default ReportReview;
